import React from 'react';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#fff0',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: 'none',
  },
}));

const TooltipNew = ({
  title,
  content,
  children,
  disable,
  placement,
  arrow,
  enterTouchDelay,
  leaveTouchDelay,
}: {
  title: string | JSX.Element;
  content: JSX.Element | string;
  children: JSX.Element;
  disable?: boolean;
  placement?:
    | 'bottom'
    | 'left'
    | 'right'
    | 'top'
    | 'bottom-end'
    | 'bottom-start'
    | 'left-end'
    | 'left-start'
    | 'right-end'
    | 'right-start'
    | 'top-end'
    | 'top-start';
  arrow?: boolean;
  enterTouchDelay?: number;
  leaveTouchDelay?: number;
}) => {
  if (disable === false) {
    return children;
  }

  return (
    <CustomTooltip
      placement={placement}
      arrow={arrow}
      enterTouchDelay={enterTouchDelay ? enterTouchDelay : 0}
      leaveTouchDelay={leaveTouchDelay ? leaveTouchDelay : 5000}
      title={
        <Card sx={{ minWidth: 275, boxShadow: '0 4px 10px -5px #0004' }}>
          <CardContent>
            <Typography variant="h6" color="text.primary" gutterBottom sx={{ fontSize: '16px' }}>
              {title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {content}
            </Typography>
          </CardContent>
        </Card>
      }
    >
      {children}
    </CustomTooltip>
  );
};

export default TooltipNew;
